export const API_URL = "/api"
export const PAGE_SIZE = 25